export const EMBEDDED_CONFLUENCE_METRICS_PREFIX = 'embedded-confluence-metrics.';
export const EMBEDDED_VIEW_TTI = 'embedded-view-tti';
export const EMBEDDED_EDITOR_TTI = 'embedded-editor-tti';
export const EMBEDDED_EDIT_CLICK = 'embedded-edit-click';
